/* eslint-disable semi */
/* eslint-disable react/prop-types */
/* eslint-disable comma-dangle */
/* eslint-disable import/newline-after-import */
/* eslint-disable quotes */
/* eslint-disable import/order */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { withRouter } from 'react-router-dom';
import TopbarMenu from './TopbarMenuLink';
import TopbarSearchbar from './TopbarSearchbar';
import { connect } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: 100000,
    color: "black",
    transition: theme.transitions.create(['width', 'margin'], {
      duration: 200,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      duration: 300,
    }),
  },
  hide: {
    display: 'none',
  },
  gridContainer: {
    display: 'flex',
    margin: 0,
    height: 50,
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    flexGrow: 1,
  },
  title: {
    paddingTop: "5px"
  }
}));

const Topbar = (props) => {
  const {
    sidebar,
    color, 
    setColor,
  } = props;
  const backgroundColor = `rgba(${color.r},${color.g} , ${color.b})`;

  const classes = useStyles();

  return (
    <div className="topbar" style={{ zIndex: 1100 }}>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: !sidebar.collapse,
        })}
        style={{ backgroundColor, zIndex: 1 }}
      >
        <Toolbar style={{ zIndex: 11, padding: 0 }}>
          <Grid className={classes.gridContainer} container spacing={4}>
            <Grid className={classes.item} item xs={2} />
            <Grid item xs={8} style={{ marginTop: '-16px' }}>
              <div className="topbar__mid">
                <TopbarSearchbar />
              </div>
            </Grid>
            <Grid className={classes.item} item xs={1} />
            <Grid
              item
              xs={1}
              style={{
                marginTop: '-16px', justifyContent: "flex-end", display: 'flex',
              }}
            >
              <div style={{ justifiyContent: 'flex-end' }}>
                <TopbarMenu color={color} setColor={setColor} />
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default withRouter(connect((state) => ({
  sidebar: state.sidebar,
  Topbar: state.Topbar,
  theme: state.theme,
  user: state.user,
}))(Topbar));

/*

       <div className="topbar__wrapper">
          <div className="topbar__left">
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
            <Link className="topbar__logo" to="/dashboard_default" />
          </div>
          <div className="topbar__mid">
            <TopbarSearchbar />
          </div>
          <div className="topbar__right">
            <TopbarProfile
              changeToDark={changeToDark}
              changeToLight={changeToLight}
              theme={theme}
            />
            <TopBarLanguage />
          </div>
        </div>

        */
